
import { SystemMediaResource } from "@/resources";
import { Component, Prop, Watch } from "vue-property-decorator";
import MediaImageStrip from "@/components/media/MediaImageStrip.vue"
import { BaseMaintenanceJobLogComponent, RequiredProjections } from "../base/BaseMixins";

@RequiredProjections("maintenanceLogDetail")
@Component({components:{MediaImageStrip}})
export default class JobLogNavigatorPanel extends BaseMaintenanceJobLogComponent {

    @Prop({default: "auto"}) height !: string
    @Prop({default: true}) constrained !: boolean
  
    @Watch("isDirty")
    reportChanged(isDirty : any) {
      if (isDirty && this.$refs.container) {
        let cObj : any = this.$refs.container
        cObj.scrollTop = 0
      }
    }

    get mediaUploadUrl() {
      return SystemMediaResource.mediaUploadUrl
    }

    get hasMedia() {
      return this.rdata.media && this.rdata.media.length > 0
    }
}
